// src/components/Footer.js (Example)
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
        <Link to="/terms-of-use">Terms of Use</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/contact">Contact Us</Link> {/* New link */}
        </div>
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} EdGeneOnline. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
